"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fill = void 0;
exports.fill = (subject, value, start, end) => {
    if (start === undefined) {
        start = 0;
    }
    if (end === undefined) {
        end = subject.length;
    }
    const results = [...subject];
    for (let i = start; i < end; i++) {
        results[i] = value;
    }
    return results;
};
//# sourceMappingURL=fill.js.map